module.exports = __webpack_public_path__ + "static/img/class_task_stu_send_yueya.1285a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class_task_stu_send_yueya.png
// module id = Q2jD
// module chunks = 2